export const NoteParticipantStatusReasons = {
  patientToBeSeenInPerson: 'REJECTED_PATIENT_NEEDS_TO_BE_SEEN',
  incorrectSpecialty: 'REJECTED_INCORRECT_SPECIALTY',
  consultantUnavailable: 'REJECTED_CONSULTANT_UNAVAILABLE',
  rejectedOther: 'REJECTED_OTHER',
  closedCompleted: 'CLOSED_COMPLETED'
};
